import React, { useState } from 'react';
import CompanyName from '../../../commonComponents/CompanyName';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType, CapitalType } from '../../../../context/AppContext';
import { ToastContainer } from 'react-toastify';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import SigningOfTheStatus from '../../../commonComponents/SigningOfTheStatus';
import { SigningOfTheStatusType } from '../../../../static/types/commonTypes/signingOfTheStatusType';
import TaxServiceRegistration from '../../../commonComponents/TaxServiceRegistration';
import { TaxServiceRegistrationType } from '../../../../static/types/commonTypes/taxServiceRegistrationType';
import RegistrationNotices from './RegistrationNotices';
import Address from '../../../commonComponents/Address';
import { AddressType } from '../../../../static/types/commonTypes/addressType';
import CapitalChange from '../../../commonComponents/CapitalChange';
import DateComponent from '../../../commonComponents/DateComponent';
import { DateType } from '../../../../static/types/commonTypes/dateType';
import AddressPlaceOppositions from './AddressPlaceOppositions';
import Manager from '../../../commonComponents/Manager';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import { RegistrationNoticesType } from '../../../../static/types/commonTypes/registrationNoticesType';
import { ManagerType } from '../../../../static/types/commonTypes/managerType';
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';
import { GoArrowRight } from 'react-icons/go';
import { FaUpload } from 'react-icons/fa';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const CessionDroitBail: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
}) => {

    const{

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        signingOfTheStatus,
        setSigningOfTheStatus,
        signingOfTheStatusValidity,
        setSigningOfTheStatusValidity,
        signingOfTheStatusChecked,
        setSigningOfTheStatusChecked,

        taxServiceRegistration,
        setTaxServiceRegistration,
        taxServiceRegistrationValidity,
        setTaxServiceRegistrationValidity,
        taxServiceRegistrationChecked,
        setTaxServiceRegistrationChecked,

        address,
        setAddress,
        addressValidity,
        setAddressValidity,
        addressChecked,
        setAddressChecked,

        transfertAmount,
        setTransfertAmount,
        transfertAmountValidity,
        setTransfertAmountValidity,
        transfertAmountChecked,
        setTransfertAmountChecked,

        date,
        setDate,
        dateValidity,
        setDateValidity,
        dateChecked,
        setDateChecked,

        registrationDate,
        setRegistrationDate,
        registrationDateValidity,
        setRegistrationDateValidity,
        registrationDateChecked,
        setRegistrationDateChecked,

        registrationNotices, setRegistrationNotices,
        registrationNoticesValidity, setRegistrationNoticesValidity,
        registrationNoticesChecked, setRegistrationNoticesChecked,
        
        typeRegistrationData,
            
        // cédant
        sellerManager, setSellerManager,
        sellerManagerValidity, setSellerManagerValidity,
        sellerManagerChecked, setSellerManagerChecked,

        // acquéreur
        buyerManager, setBuyerManager,
        buyerManagerValidity, setBuyerManagerValidity,
        buyerManagerChecked, setBuyerManagerChecked,

        typeOppositionData,
        setTypeOppositionData,

        locationOppositionsRegistry,
        setLocationOppositionsRegistry,
        locationOppositionsRegistryValidity,
        setLocationOppositionsRegistryValidity,
        locationOppositionsRegistryChecked,
        setLocationOppositionsRegistryChecked,

        validityOppositionLocation,
        setValidityOppositionLocation,
        validityOppositionLocationValidity,
        setValidityOppositionLocationValidity,
        validityOppositionLocationChecked,
        setValidityOppositionLocationChecked,

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [ submissive, setSubmissive ] = useState<boolean>( false );
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const statusSignatureText = ( statusSignature: SigningOfTheStatusType ): string => {
                let res = ``
                if( statusSignature.actNature === "acte sous seing privé") res = `Par acte SSP du ${ statusSignature.actDate }`
                else res = `Par acte authentique du  ${ statusSignature.actDate }`
                return res
            }

            const taxRegistrationText = ( taxtRegistrationService: TaxServiceRegistrationType ): string => {
                let res = ``
                if( taxtRegistrationService.taxService.includes("(SIE)")) res = `enregistré au SIE ${ getCityWithPreposition( taxtRegistrationService.taxVille) }`
                else res = `enregistré au SDE ${ getCityWithPreposition( taxtRegistrationService.taxVille) }`
                return res
            }

            const registrationNoticesText = ( date: DateType, registrationNotice: RegistrationNoticesType ): string => {
                let res = ``
                if( registrationNotice.numberProvided === "bordereau" ){
                    res = `le ${ date.date }, Bordereau no ${ registrationNotice.bordereau?.numeroBordereau }, Case no ${ registrationNotice.bordereau?.numeroCase } ${ registrationNotice.bordereau?.numeroExtrait ? `, ext ${ registrationNotice.bordereau?.numeroExtrait }` : ''}`
                }
                else if( registrationNotice.numberProvided === "dossier" ){
                    res = `le ${ date.date }, Dossier no ${ registrationNotice.dossier?.numeroDossier } ${ registrationNotice.dossier?.numeroReference ? `, Référence ${ registrationNotice.dossier?.numeroReference }` : '' }`
                }
                return res
            }
            
            const managerText = ( manager: ManagerType ): string => {
                if (manager.person === "Personne morale") {
                    return ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${ manager.entityDetails.isRcsRegistering ? `en cours d'immatriculation au RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` : `${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` } `
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
                else return ""
            }

            const transfertAmountText = ( capital: CapitalType ): string => {
                return `Prix principal : ${ capital.capital } €.`
            }

            const localAddressText = ( address: AddressType ): string => {
                return `le droit au bail du local situé ${ address.address } ${ address.additionalAddress ? `${ address.additionalAddress}` : ''} ${ address.postalCode } ${ address.city }`
            }

            const entryDateText = ( date: DateType ): string => {
                return `Date d'entrée en jouissance : ${ date.date }`
            }

            const oppositionLocationText = ( correspodenceAddress: AddressType, validityAddress: AddressType, isSameAddress: number ): string => {
                let res = ``
                if( isSameAddress === 0 ){
                    res = `Les oppositions sont reçues dans les 10 jours de la dernière date des publicités légales à l'adresse suivante : ${ correspodenceAddress.address } ${ correspodenceAddress.additionalAddress ? `${ correspodenceAddress.additionalAddress}` : ''} - ${ correspodenceAddress.postalCode } ${ correspodenceAddress.city }.`
                }
                else if( isSameAddress === 1 ){
                    res = `Les oppositions sont reçues dans les 10 jours de la dernière date des publicités légales aux adresses suivantes : ${ correspodenceAddress.address } ${ correspodenceAddress.additionalAddress ? `${ correspodenceAddress.additionalAddress}` : ''} - ${ correspodenceAddress.postalCode } ${ correspodenceAddress.city } pour la correspondance et ${ validityAddress.address } ${ validityAddress.additionalAddress ? `${ validityAddress.additionalAddress}` : ''} - ${ validityAddress.postalCode } ${ validityAddress.city }pour la validité.`
                }
                return res
            }

            e.preventDefault();

            const tempText = `${ statusSignatureText( signingOfTheStatus )}, ${ taxRegistrationText( taxServiceRegistration )}, ${ registrationNoticesText( registrationDate, registrationNotices )},
${ managerText( sellerManager )},
A cédé à
${ managerText( buyerManager )},
${ localAddressText( address )},
${ transfertAmountText( transfertAmount )},
${ entryDateText( date )},
${ oppositionLocationText( locationOppositionsRegistry, validityOppositionLocation, typeOppositionData )}
`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination (companyName.companyName);
            setSubmissive (true)
        }
        
    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        } else if (!signingOfTheStatusValidity) {
            setActiveTab('signingOfTheStatus')
        } else if (!taxServiceRegistrationValidity) {
            setActiveTab('taxServiceRegistration')
        } else if ( !( registrationDateValidity && registrationNoticesValidity )) {
            setActiveTab('registrationNotices')
        } else if ( !sellerManagerValidity) {
            setActiveTab('transferor')
        } else if ( !buyerManagerValidity ) {
            setActiveTab('purchaser')
        } else if ( !addressValidity ) {
            setActiveTab('address')
        } else if ( !transfertAmountValidity ) {
            setActiveTab('amountTransfer')
        } else if ( !dateValidity ) {
            setActiveTab('dateEntryEnjoyment')
        } else if ( typeOppositionData === 0 ) {
            if( !locationOppositionsRegistryValidity )
            setActiveTab('addressPlaceOppositions')
        } else if ( typeOppositionData === 1 ) {
            if( !( locationOppositionsRegistryValidity && validityOppositionLocationValidity ))
            setActiveTab('addressPlaceOppositions')
        }

        let temp_registrationNotivesValidity = registrationDateValidity && registrationNoticesValidity

        let temp_oppositionLocationValidity = typeOppositionData === 0
        ? locationOppositionsRegistryValidity
        : locationOppositionsRegistryValidity && validityOppositionLocationValidity

        return companyNameValidity && signingOfTheStatusValidity && taxServiceRegistrationValidity && temp_registrationNotivesValidity && sellerManagerValidity && buyerManager && addressValidity && transfertAmountValidity && dateValidity && temp_oppositionLocationValidity;
            
    };
    
    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked (true)
            if(companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "signingOfTheStatus") {
            setSigningOfTheStatusChecked (true)
            if(signingOfTheStatusValidity) {
                switchTab(getNextTab("signingOfTheStatus"));
            }
        } else if (activeTab === "taxServiceRegistration") {
            setTaxServiceRegistrationChecked (true)
            if(taxServiceRegistrationValidity) {
                switchTab(getNextTab("taxServiceRegistration"));
            }
        } else if (activeTab === "registrationNotices") {
            if(typeRegistrationData === 'bordereau' || typeRegistrationData === 'dossier') {
                setRegistrationDateChecked (true)
                setRegistrationNoticesChecked (true)
                if (registrationDateValidity && registrationNoticesValidity) {
                    switchTab(getNextTab("registrationNotices"))
                }
            }
        } else if (activeTab === "transferor") {
            setSellerManagerChecked (true)
            if ( sellerManagerValidity ) {
                switchTab(getNextTab("transferor"))
            }
        } else if (activeTab === "purchaser") {
            setBuyerManagerChecked (true)
            if ( buyerManagerValidity ) {
                switchTab(getNextTab("purchaser"))
            }
        } else if (activeTab === "address") {
            setAddressChecked (true)
            if ( addressValidity ) {
                switchTab(getNextTab("address"))
            }
        } else if (activeTab === "amountTransfer") {
            setTransfertAmountChecked (true)
            if ( transfertAmountValidity ) {
                switchTab(getNextTab("amountTransfer"))
            }
        } else if (activeTab === "dateEntryEnjoyment") {
            setDateChecked (true)
            if ( dateValidity ) {
                switchTab(getNextTab("dateEntryEnjoyment"))
            }
        } else if (activeTab === "addressPlaceOppositions") {
            setLocationOppositionsRegistryChecked (true)
            if( typeOppositionData === 1 ){
                setValidityOppositionLocationChecked( true )
                if ( locationOppositionsRegistryValidity && validityOppositionLocationValidity ) {
                    setSubmissive( true )
                }
            }
            else{
                if ( locationOppositionsRegistryValidity ) {
                    setSubmissive( true )
                }
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive( false )
    };

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "signingOfTheStatus";
        else if (currentTab === "signingOfTheStatus") return "taxServiceRegistration";
        else if (currentTab === "taxServiceRegistration") return "registrationNotices";
        else if (currentTab === "registrationNotices") return "transferor";
        else if (currentTab === "transferor") return "purchaser";
        else if (currentTab === "purchaser") return "address";
        else if (currentTab === "address") return "amountTransfer";
        else if (currentTab === "amountTransfer") return "dateEntryEnjoyment";
        else if (currentTab === "dateEntryEnjoyment") return "addressPlaceOppositions";
        else return currentTab;
    }

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "addressPlaceOppositions") return "dateEntryEnjoyment";
        else if (currentTab === "dateEntryEnjoyment") return "amountTransfer";
        else if (currentTab === "amountTransfer") return "address";
        else if (currentTab === "address") return "purchaser";
        else if (currentTab === "purchaser") return "transferor";
        else if (currentTab === "transferor") return "registrationNotices";
        else if (currentTab === "registrationNotices") return "taxServiceRegistration";
        else if (currentTab === "taxServiceRegistration") return "signingOfTheStatus";
        else return currentTab;
    }

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName ({...companyName, ...data});
    const updateSigning = (data: Partial<SigningOfTheStatusType>) => setSigningOfTheStatus ({...signingOfTheStatus, ...data})
    const updateTaxService = (data: Partial<TaxServiceRegistrationType>) => setTaxServiceRegistration ({...taxServiceRegistration, ...data})
    const updateAddress = ( partialAddress: Partial<AddressType> ) => setAddress({ ...address, ... partialAddress })
    const updateDate = (data: Partial<DateType>) => setDate ({...date, ...data});
    const tabs = [
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'signingOfTheStatus', label: 'Acte de cession de fonds'},
        {key: 'taxServiceRegistration', label: 'Enregistrement du service des impôts'},
        {key: 'registrationNotices', label: "Mention d'enregistrement"},
        {key: 'transferor', label: 'Cédant'},
        {key: 'purchaser', label: 'Acquéreur'},
        {key: 'address', label: "L'adresse des locaux"},
        {key: 'amountTransfer', label: 'Montant de la cession'},
        {key: 'dateEntryEnjoyment', label: "Date d'entrée en jouissance"},
        {key: 'addressPlaceOppositions', label: "Adresse du lieu des oppositions"},

    ]
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' && 
                        <div>
                            <span className='mb-2'>
                                Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                            </span>
                            <div className="tab-content">
                                <CompanyName
                                    changeCompanyName={updateCompanyName}
                                    checked = {companyNameChecked}
                                    companyName= {companyName}
                                    onValidationChange={(isValid: boolean) => setCompanyNameValidity (isValid)}
                                    showClientReference= {true}
                                />
                            </div>
                        </div>
                }

                {
                    activeTab === 'signingOfTheStatus' &&
                        <SigningOfTheStatus
                            actDateLabel="Date de l'acte"
                            actNature={[
                                "acte sous seing privé",
                                "acte authentique"
                            ]}
                            checked= {signingOfTheStatusChecked}
                            signingOfTheStatus={signingOfTheStatus}
                            updateSigningOfTheStatus={updateSigning}
                            showPlaceSignature= {false}
                            onValidationChange={(isValid: boolean) => setSigningOfTheStatusValidity (isValid)}
                        />
                }

                {
                    activeTab === 'taxServiceRegistration' && 
                        <TaxServiceRegistration
                            checked= {taxServiceRegistrationChecked}
                            taxServiceRegistration={taxServiceRegistration}
                            updateTaxServiceRegistration={updateTaxService}
                            onValidationChange={(isValid: boolean) => setTaxServiceRegistrationValidity (isValid)}
                            taxServiceOption={[
                                "Service des impôts des entreprises (SIE)",
                                "Service départemental des Enregistrements (SDE)"
                            ]}
                        />
                }

                {
                    activeTab === 'registrationNotices' &&
                        <RegistrationNotices />
                }

                {   
                    activeTab === 'transferor' && 
                    <Manager
                        checked = { sellerManagerChecked }
                        manager = { sellerManager }
                        setChecked = { setSellerManagerChecked }
                        updateManagerValidity={ setSellerManagerValidity }
                        setManager = { setSellerManager }
                        showRcsCheckBox = { true }
                        societyType = { societyTypeOptions }
                        draftFieldName = 'sellerManager'
                    />
                }

                {   
                    activeTab === 'purchaser' && 
                    <Manager
                        checked = { buyerManagerChecked }
                        manager = { buyerManager }
                        setChecked = { setBuyerManagerChecked }
                        updateManagerValidity={ setBuyerManagerValidity }
                        setManager = { setBuyerManager }
                        showRcsCheckBox = { true }
                        societyType = { societyTypeOptions }
                        draftFieldName = 'buyerManager'
                    />
                }

                {   
                    activeTab === 'address' && 
                    <Address
                        checked= {addressChecked}
                        address= {address}
                        draftFieldName = 'address'
                        changeAddress={updateAddress}
                        onValidationChange={(isValid: boolean) => setAddressValidity (isValid)}
                    />
                }

                {  
                    activeTab === 'amountTransfer' && 
                        <CapitalChange
                            inputLabel='Montant en euros'
                            fieldKey='transfertAmount'
                            checked= {transfertAmountChecked}
                            capital={transfertAmount}
                            onChange={(data: Partial<CapitalType> ) => setTransfertAmount ({...transfertAmount, ...data})}
                            onValidationChange={(isValid: boolean) => setTransfertAmountValidity (isValid)}
                        />
                }

                {
                    activeTab === 'dateEntryEnjoyment' && 
                        <div className="col-md-6">
                            <DateComponent
                                id='date'
                                dateLabel = "Date d'effet"
                                date = { date }
                                checked = { dateChecked }
                                changeDate = { updateDate }
                                required = { true }
                                onValidationChange = {( isValid: boolean ) => setDateValidity ( isValid )}
                            />
                        </div>
                }

                {   
                    activeTab === 'addressPlaceOppositions' &&
                        <AddressPlaceOppositions />
                }

                {
                    submissive &&
                    activeTab === 'addressPlaceOppositions' && 
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={ txtAnnonce }
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px',fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                        )}

                        {
                            activeTab === 'addressPlaceOppositions' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            activeTab !== 'addressPlaceOppositions' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            submissive && activeTab === 'addressPlaceOppositions' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )} 
                    </div>
                </div>
                
            </form>
        </>
    );
};

export default CessionDroitBail;